import { FaChevronCircleLeft, FaChevronCircleRight } from "react-icons/fa";
import { useLocation, useHistory } from "react-router-dom";

const locations = [
  {
    location: "/where",
    position: 0,
  },
  {
    location: "/when",
    position: 1,
  },
  {
    location: "/what",
    position: 2,
  },
  {
    location: "/anything",
    position: 3,
  },
  {
    location: "/budget",
    position: 4,
  },
  {
    location: "/confirm",
    position: 5,
  },
];

const Footer = ({ height }) => {
  return (
    <footer
      className="w-full bg-white"
      style={{ borderTop: "1px solid #eaeaea" }}
    >
      <div className=" mt-8 ">
        <div className="container mx-auto py-4 px-8 ">
          <div className="flex md:flex-row flex-col text-center md:text-left">
            <div className="md:order-2">
              <div className="md:flex lowercase">
                <a href="//themirum.co.uk/terms-and-conditions" target="_blank">
                  Terms &amp; Conditions
                </a>
              </div>
            </div>
            <div className="grow md:order-1 mt-4 md:mt-0">
              <p className="text-sm">
                &#169; copyright 2026, mirum | designed & developed by{" "}
                <a
                  href="https://www.letscreateltd.com"
                  className="text-black font-black"
                >
                  Let's Create.
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
